import axiosInstance from '../../interceptor/axiosInstance';
import {
    LOCAL_BASE_URL,
    HL_KT_EXCEL_UPLOADS,
    HL_KT_EXCEL_VALIDATE_STRUCTURE,
    HL_KT_EXCEL_VALIDATE_DATA,
    HL_KT_EXCEL_VALIDATE_KT,
    HL_KT_EXCEL_IMPORT_STREAM,
} from '../../routes/routeConstants/apiRoutes';

export interface KtImportProgress {
    status: 'processing' | 'complete' | 'failed';
    progress?: number;
    processed?: number;
    total?: number;
    created_count?: number;
    updated_count?: number;
    error?: string;
}

const resolveUrl = (template: string, agreementId: string) =>
    template.replace(':agreementId', agreementId);

export class KtExcelUploadService {
    static async uploadFile(agreementId: string, file: File): Promise<string> {
        const formData = new FormData();
        formData.append('file', file);
        const response = await axiosInstance.post(resolveUrl(HL_KT_EXCEL_UPLOADS, agreementId), formData);
        return response.data['filename'];
    }

    static async validateStructure(agreementId: string, filename: string): Promise<void> {
        await axiosInstance.post(resolveUrl(HL_KT_EXCEL_VALIDATE_STRUCTURE, agreementId), { filename });
    }

    static async validateData(agreementId: string, filename: string): Promise<void> {
        await axiosInstance.post(resolveUrl(HL_KT_EXCEL_VALIDATE_DATA, agreementId), { filename });
    }

    static async validateKt(agreementId: string, filename: string): Promise<void> {
        await axiosInstance.post(resolveUrl(HL_KT_EXCEL_VALIDATE_KT, agreementId), { filename });
    }

    static importStream(
        agreementId: string,
        filename: string,
        onProgress: (event: KtImportProgress) => void,
        onComplete: (event: KtImportProgress) => void,
        onError: (error: string) => void
    ): EventSource {
        const token = localStorage.getItem('ACCESS_TOKEN') ?? '';
        document.cookie = `access_token=${token}; path=/`;

        const url = `${LOCAL_BASE_URL}${resolveUrl(HL_KT_EXCEL_IMPORT_STREAM, agreementId)}?filename=${encodeURIComponent(filename)}`;
        const es = new EventSource(url, { withCredentials: true });

        let completed = false;

        const cleanup = () => {
            es.close();
            document.cookie = 'access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
        };

        es.onmessage = (event) => {
            const data: KtImportProgress = JSON.parse(event.data);
            if (data.status === 'processing') {
                onProgress(data);
            } else if (data.status === 'complete') {
                completed = true;
                cleanup();
                onComplete(data);
            } else if (data.status === 'failed') {
                completed = true;
                cleanup();
                onError(data.error || 'Import failed');
            }
        };

        es.onerror = () => {
            if (completed) return;
            cleanup();
            onError('Connection lost during import');
        };

        return es;
    }
}
